import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'app-config-list',
    templateUrl: './config-list.component.html',
    styleUrls: ['./config-list.component.scss']
})
export class ConfigListComponent {
    @Input() modelo: any;
    @Input() cromado: any;
    @Input() extColor: any;
    @Input() intColor: any;
    @Input() accesories: Array<any>;
    @Output() fireDelete = new EventEmitter<any>();

    deleteAccesorie(i, prop) {
        this.fireDelete.emit({ index: i, accesorie: prop });
    }
}